import { useCurrentBreakPoint } from 'telia-front-react';

export const useIsMobileHook = () => {
  const currentBreak = useCurrentBreakPoint();
  const isMobile = currentBreak === 'xs' || currentBreak === 'sm';
  const isMobileOrTablet = isMobile || currentBreak === 'md';
  return { isMobile, isMobileOrTablet };
};
